import React, { MouseEvent } from 'react'

import { Icon, typography } from '@joor/design-system'
import styled from 'styled-components'

const Container = styled.div`
  min-height: 48px;
  text-align: left;
  background-color: var(--color-neutral-000-full);
  border: 2px solid var(--color-secondary-700);
  border-radius: var(--size-border-radius-small);
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  box-sizing: content-box;
  ${typography.alpha.primaryActive.body3}

  &.multiple-files {
    margin-bottom: 4px;
  }
`

const Title = styled.label`
  color: var(--color-primary-900) !important;
  font-weight: var(--font-weight-medium);
  margin: auto 0px;
  grid-area: title;
`

const CloseButton = styled(Icon)`
  grid-area: close;
  justify-self: end;
  cursor: pointer;
`

interface FileSelectedBoxProps {
  title: string
  onDelete: (e: MouseEvent, title: string) => void
  multipleFiles: boolean
}

const FileSelectedBox: React.FC<FileSelectedBoxProps> = ({
  title,
  onDelete,
  multipleFiles,
}) => (
  <Container className={multipleFiles ? 'multiple-files' : ''}>
    <Title>{title}</Title>
    <CloseButton iconName="close" onClick={(e) => onDelete(e, title)} />
  </Container>
)

export default FileSelectedBox
